import { useAppStateStore } from '@/stores/appState.js';

export default {
    data() {
        return {
            formIsDirty: false,
            displayMessage: null,
            prevLocation:"",
            isLocationChanged: false,
            _dirtyCheckInProgress: false,
            _navConfirmInProgress: false
        };
    },
    methods: {
        preventNav: function(event) {
            if (!this.formIsDirty) return;
            event.preventDefault();
            event.returnValue = '';
        },
        dataLoaded: function() {
            setTimeout(() => {
                this.formIsDirty = false;
            }, 0);
        },
        dataSaved: function() {
            this.formIsDirty = false;
        },
        async warnBeforeLeaving(next) {
            await this.$bvModal
                .msgBoxConfirm([this.displayMessage])
                .then(value => {
                    if (!value) {
                        if(this.isLocationChanged){
                            useAppStateStore().updateSelectedLocationId(this.prevLocation);
                            localStorage.setItem(this.filterName, this.prevLocation);
                            this.isLocationChanged = false;
                        }
                        next(false);
                        return;
                    } else{
                        this.isLocationChanged = false;
                        next();
                    }
                });
        },
        checkDirtyBeforeModalClose(bvModalEvt, modalName) {
            if (!this.formIsDirty) return;
            // Prevent modal from closing while we ask the user.
            bvModalEvt.preventDefault();
            // BVN can fire `hide` multiple times for a single user action — make sure
            // we only show the warning once at a time.
            if (this._dirtyCheckInProgress) return;
            this._dirtyCheckInProgress = true;
            this.$bvModal
                .msgBoxConfirm([this.displayMessage])
                .then(value => {
                    this._dirtyCheckInProgress = false;
                    if (value) {
                        this.dataSaved();
                        if (modalName) {
                            this.$nextTick(() => this.$bvModal.hide(modalName));
                        }
                    }
                });
        }
    },
    beforeMount() {
        window.addEventListener('beforeunload', this.preventNav);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.preventNav);
        this._isMounted = false;
        if (this._removeRouteGuard) {
            this._removeRouteGuard();
        }
    },
    computed: {
        selectedLocation(){
            return useAppStateStore().getSelectedLocationId;
        }
    },
    watch: {
        selectedLocation: {
            deep: true,
            handler: function(newVal, oldVal) {
                this.prevLocation = oldVal;
                this.isLocationChanged = true;
            }
        }
    },
    $watcher: {
        handler: function() {
            this.formIsDirty = true;
        },
        deep: true
    },
    created() {
        this.displayMessage = "Are you sure you want to leave without saving? Select OK to discard changes or Cancel to return to editing.";

        // Vue Router 4 doesn’t call beforeRouteLeave from mixins,
        // so we register a global beforeEach guard scoped to this component
        // eslint-disable-next-line no-unused-vars
        this._removeRouteGuard = this.$router.beforeEach(async (to, from) => {
            if (!this.formIsDirty) return;
            // Only guard if this component is still mounted
            if (!this._isMounted) return;
            // Browser back/forward can re-trigger this guard while the confirm is
            // still open (cancelling the nav reverts the URL, which fires another
            // navigation; rapid clicks queue more). Without this, each one awaits a
            // fresh msgBoxConfirm and the modals stack. Block the extra navigations
            // instead of opening another modal.
            if (this._navConfirmInProgress) return false;
            this._navConfirmInProgress = true;
            let confirmed;
            try {
                confirmed = await this.$bvModal.msgBoxConfirm(this.displayMessage);
            } finally {
                this._navConfirmInProgress = false;
            }
            if (!confirmed) {
                if (this.isLocationChanged) {
                    useAppStateStore().updateSelectedLocationId(this.prevLocation);
                    localStorage.setItem(this.filterName, this.prevLocation);
                    this.isLocationChanged = false;
                }
                return false;
            }
            this.formIsDirty = false;
            this.isLocationChanged = false;
        });
        this._isMounted = true;
    }
};